<template>
    <div class="slider-item slider-item--final">
        <h2 ref="title" class="slider-item__title">
            {{ title }}
        </h2>
        <img src="/ressources/logged/img/illustrations/recap2024/shape-recap.svg" width="277" />
        <div v-if="hasButton" ref="actionButton">
            <CompassButton
                type="secondary-contrast"
                :label="$t.__('recap.slider.FinalSlide.button')"
                @click="handleClick"
            />
        </div>
    </div>
</template>
<script>
import 'splitting/dist/splitting.css';
import 'splitting/dist/splitting-cells.css';
import Splitting from 'splitting';
import anime from 'animejs';

export default {
    name: 'FinalSlide',
    props: {
        title: {
            type: String,
            required: true,
        },
        hasButton: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        isActive(value) {
            if (value) {
                const animatedTimeline = anime.timeline();

                animatedTimeline
                    .add({
                        targets: this.$refs.title.querySelectorAll('.word'),
                        translateY: [40, 0],
                        opacity: [0, 1],
                        delay: anime.stagger(50, { start: 300 }),
                    })
                    .add(
                        {
                            targets: this.$refs.actionButton,
                            translateY: [40, 0],
                            opacity: [0, 1],
                        },
                        '-=600',
                    );
            } else {
                this.$refs.actionButton?.removeAttribute('style');
                const items = this.$refs.title.querySelectorAll('.word');
                for (const item of items) {
                    item.removeAttribute('style');
                }
            }
        },
    },
    mounted() {
        Splitting({ target: this.$refs.title, by: 'words' });
    },
    methods: {
        handleClick() {
            this.$router.push({ name: 'dashboard' });
        },
    },
};
</script>
<style lang="scss" scoped>
.slider-item {
    gap: 40px;

    &__title {
        color: #fff;
        font-family: var(--font-families-stack-sans-text), sans-serif;
        font-size: 34px;
        font-weight: 400;
        line-height: 36px;
        margin: 0;
        position: relative;
        text-align: center;
        z-index: 1;

        :deep(.word) {
            opacity: 0;
        }
    }

    img {
        bottom: -2px;
        left: 0;
        position: absolute;
    }
}
</style>
